'use strict';

var Misc = require('utils/misc');
var Requests = require('utils/requests');

var MiniaturSchemes = Marionette.ItemView.extend({
    template: require('components/devices/templates/gateway/miniatur_schemes'),

    serializeData: function () {
        var data = Marionette.LayoutView.prototype.serializeData.apply(this, arguments);

        data.schema = $.extend(true, {}, this.options.models);
        for (var idx = 0; idx < this.options.models.length; idx++) {
            data.schema[idx] = data.schema[idx].attributes;
            data.schema[idx].modelType = 'device';
        }
        data.hasSchemas = _.keys(data.schema).length > 0;

        return data;
    },

    onAttach: function () {
        var self = this;
        _.each(this.options.models, function (model, idx) {
            var loadSchemaFromUrls = function (i, notFound) {
                if (!model.canShowScheme()) {
                    notFound();
                    return;
                }
                var type = model.get('type');
                var id = model.id;
                var schema = model.get('schema') || '';
                var schemaURLs = Requests.getSchemaURLs(id, type, schema);
                if (i == schemaURLs.length) {
                    notFound();
                    return;
                }

                self.loadMiniaturSchema(
                    self,
                    schemaURLs[i],
                    function () {
                        loadSchemaFromUrls(i + 1, notFound);
                    },
                    idx
                );
            };
            $('#js-info-link-' + idx).hide();
            $('.js-schema-notfound-' + idx).hide();
            $('.js-firmware-not-sufficient-' + idx).hide();

            loadSchemaFromUrls(0, function () {
                $('#js-schema-link-' + idx).hide();
                $('#js-info-link-' + idx).show();
                if (model.canShowScheme()) {
                    $('.js-schema-notfound-' + idx).show();
                } else {
                    $('.js-firmware-not-sufficient-' + idx).show();
                }
            });
        });
        Misc.equalizeHeight($('.js-miniatur-scheme'));
    },

    loadMiniaturSchema: function (self, url, error_cb, idx) {
        // replace SVG object with actual SVG to allow manipulation
        // via jQuery - see - http://stackoverflow.com/a/11978996
        var schemaObject = $('#schema-svg-' + idx);

        $.get(
            url,
            function (data) {
                var svg = $(data).find('svg');
                svg = svg.attr('id', 'schema-svg-' + idx);

                schemaObject.replaceWith(svg);
                // see http://stackoverflow.com/a/13654655
                $('#schema-container-' + idx).html($('#schema-container-' + idx).html());
                self.delegateEvents();
                self.hideLegend(idx);

                // fit the graphic into the cardbox
                $('#schema-container-' + idx)
                    .find('svg')
                    .removeAttr('height');
                $('#schema-container-' + idx)
                    .find('svg')
                    .removeAttr('width');
                $('#schema-container-' + idx)
                    .find('svg')
                    .attr('preserveAspectRatio', 'xMinYMin meet');
                $('#schema-container-' + idx)
                    .find('svg')
                    .attr('width', '100%');
                $('#schema-container-' + idx)
                    .find('svg')
                    .attr('height', '100%');
            },
            'xml'
        ).fail(function () {
            error_cb();
        });
    },

    hideLegend: function (idx) {
        $('#legend').remove();
        $('#schema-container-' + idx)
            .find('#_x35_573')
            .remove();
        $('#schema-container-' + idx)
            .find('#_x35_575')
            .remove();
        $('#schema-container-' + idx)
            .find('#_x35_576')
            .remove();
        $('#schema-container-' + idx)
            .find('#_x35_578')
            .remove();
        $('#schema-container-' + idx)
            .find('#_x35_579')
            .remove();
        $('#schema-container-' + idx)
            .find('#_x35_573_1_')
            .remove();
    },
});

module.exports = MiniaturSchemes;
